//Libs
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
//Componentes Material
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Grid from '@material-ui/core/Grid';
//Modelos
import QuestionarioQuestao from '../../models/QuestionarioQuestao';
import ErroQuestionarioQuestao from '../../models/ErroQuestionarioQuestao';

/**
 * Componente para renderizar os campos da questão com texto fixo
 */
class QuestaoConteudo extends Component {
    constructor(props) {
        super(props);
        //Bindigs
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    /**
     * Trata as alterações no checkbox
     * @param {*} event Objeto contendo os dados do vento
     */
    handleCheckboxChange(event) {
        //Não dispara a alteração se for somente leitura
        if (!this.props.readOnly) {
            //Copia o valor recebido
            const questao = QuestionarioQuestao.clone(this.props.questao);
            //Atualiza somente o valor do campo alterado
            questao.exibeResultado = event.target.checked;
            //Atualiza o estado
            if (this.props.onChange)
                this.props.onChange(questao);
        }
    }

    /**
     * Trata a alteração nos campos do componente
     * @param {*} event Objeto contendo os dados do evento
     */
    handleChange(event) {
        //Não dispara a alteração se for somente leitura
        if (!this.props.readOnly) {
            //Copia o valor recebido
            const questao = QuestionarioQuestao.clone(this.props.questao);
            //Atualiza o título
            questao[event.target.name] = event.target.value;
            //Atualiza o estado
            if (this.props.onChange)
                this.props.onChange(questao);
        }
    }

    render() {
        const { questao, erros } = this.props;

        return (
            <Fragment>
                <Grid item xs={12} sm="auto" >
                    <FormControl fullWidth variant="standard" error={!!erros.exibeResultado} >
                        <FormControlLabel
                            id="exiberesultado-label"
                            control={
                                <Checkbox
                                    checked={questao.exibeResultado}
                                    onChange={this.handleCheckboxChange}
                                    name="exibeResultado"
                                    color="primary"
                                />
                            }
                            label="Exibe no resultado"
                        />
                        <FormHelperText id="exiberesultado-helper">{erros.exibeResultado}</FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={12} >
                    <TextField
                        name="conteudoTexto" 
                        label="Conteúdo" 
                        type="text" 
                        multiline
                        placeholder="Conteúdo" 
                        variant="outlined" 
                        size="small"
                        fullWidth 
                        required
                        error={!!erros.conteudoTexto}
                        helperText={erros.conteudoTexto}
                        value={questao.conteudoTexto} 
                        onChange={this.handleChange} 
                    />  
                </Grid>
            </Fragment>
        );
    }
}

QuestaoConteudo.propTypes = {
    /** Dados da questão */
    questao: PropTypes.instanceOf(QuestionarioQuestao).isRequired,
    /** Mensagens de erro da questão, referente as opções de resposta */
    erros: PropTypes.instanceOf(ErroQuestionarioQuestao),
    /** Identifica se o componente é somente leitura e não permite alterações */
    readOnly: PropTypes.bool,
    /** Evento disparado quando há alteração nas opções da questão */
    onChange: PropTypes.func
};

QuestaoConteudo.defaultProps = {
    erros: new ErroQuestionarioQuestao(),
    readOnly: false
};

export default QuestaoConteudo;